export default __webpack_public_path__ + "static/media/poi-drivingLicense-back.630bcf28.png";